import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'
import moment from 'moment'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { Return } from 'modules/core/lib/asyncAction'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'
import app from 'modules/core/store/models/app'

import CreateRequestModal from 'modules/attendance/components/ClockIn/Shifts/HourlyShifts/HourlyTable/DayRow/ShiftPanelTableBody/ShiftRow/EditTimesheetModal/CreateRequestModal'
import { useShiftActions } from 'modules/attendance/hooks/shifts/useShiftActions'

interface Props {
  shift: TimesheetPageShiftFragment
  hasEditTimesheetAuthorization: boolean
  refreshTimesheet?: () => Promise<Return<void>>
  disabled?: boolean
  fetchDependencies: boolean
}

const DeleteButton = ({
  shift,
  hasEditTimesheetAuthorization,
  refreshTimesheet,
  disabled,
  fetchDependencies,
}: Props) => {
  const [showDeleteShiftModal, setShowDeleteShiftModal] = React.useState(false)
  const [showEditTimesheetModal, setShowEditTimesheetModal] = React.useState(false)
  const { deleteShift, loadingDelete } = useShiftActions()

  const onClick = () => {
    if (hasEditTimesheetAuthorization) {
      track(trackingEvents.timeTracking.addShiftRequestDeleteStart)
      setShowEditTimesheetModal(true)
    } else {
      setShowDeleteShiftModal(true)
    }
  }

  const onDeleteShift = async () => {
    if (showDeleteShiftModal) {
      const payload = {
        id: shift.id,
        date: shift.referenceDate,
        fetchDependencies: fetchDependencies,
      }
      const result = await deleteShift(payload)
      const handled = handleResult(result, () => undefined)

      if (handled.success) {
        dispatch({
          type: EventTypes.ATTENDANCE_SHIFT_TOGGLED,
        })
        refreshTimesheet && refreshTimesheet()

        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
        })
        setShowDeleteShiftModal(false)
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('time_tracking.delete.error'),
        })
        setShowDeleteShiftModal(true)
      }
    }
  }

  return (
    <>
      <Box alignItems="center">
        <Button type="secondary" onClick={onClick} iconName="delete" disabled={!!disabled} />
      </Box>
      {showDeleteShiftModal && (
        <Modal
          illustration="delete"
          title={i18n.t('time_tracking.delete.title')}
          description={i18n.t('time_tracking.delete.description')}
          onClose={() => setShowDeleteShiftModal(false)}
          onSubmit={onDeleteShift}
          footer={
            <Button type="negative" submit disabled={loadingDelete}>
              {i18n.t('common.delete')}
            </Button>
          }
        />
      )}
      {showEditTimesheetModal && (
        <CreateRequestModal
          onCloseModal={() => setShowEditTimesheetModal(false)}
          shift={shift}
          date={moment(shift.date)}
          refreshTimesheet={refreshTimesheet}
          employeeId={shift.employeeId}
          isDeleteRequest
        />
      )}
    </>
  )
}

export default DeleteButton
